var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIAcademyReverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#4909AA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_703_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.375 13.5325V15.9913C5.375 16.63 5.725 17.225 6.285 17.5313L10.66 19.92C11.185 20.2088 11.815 20.2088 12.34 19.92L16.715 17.5313C17.275 17.225 17.625 16.63 17.625 15.9913V13.5325L12.34 16.42C11.815 16.7088 11.185 16.7088 10.66 16.42L5.375 13.5325ZM10.66 5.08L3.28375 9.105C2.68 9.4375 2.68 10.3125 3.28375 10.645L10.66 14.67C11.185 14.9588 11.815 14.9588 12.34 14.67L19.375 10.8288V16C19.375 16.4813 19.7687 16.875 20.25 16.875C20.7312 16.875 21.125 16.4813 21.125 16V10.3913C21.125 10.0675 20.95 9.77875 20.67 9.62125L12.34 5.08C11.815 4.8 11.185 4.8 10.66 5.08V5.08Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_703_44"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(1 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIAcademyReverse);
export default __webpack_public_path__ + "static/media/IAcademy-reverse.1d9b681fb925571deb348852a4a92742.svg";
export { ForwardRef as ReactComponent };